import { useState, useRef, useEffect } from 'react';

const CUT_HEIGHTS = { small: 300, medium: 500 };

function TextWithCut({ cut, value, label }) {
    const [expanded, setExpanded] = useState(false);
    const [overflows, setOverflows] = useState(false);
    const contentRef = useRef(null);
    cut = cut || 'none';

    useEffect(() => {
        if (contentRef.current) {
            setOverflows(contentRef.current.scrollHeight > 50 + contentRef.current.clientHeight);
        }
    }, [value, cut]);

    if (cut === 'none') {
        return (
            <div style={{ marginBottom: '16px' }}>
                {label}
                <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.5, textAlign: 'justify' }}>{value}</div>
            </div>
        );
    }

    const maxHeight = CUT_HEIGHTS[cut] ?? 80;

    return (
        <div style={{ marginBottom: '16px' }}>
            {label}
            <div style={{ position: 'relative' }}>
                <div ref={contentRef} style={{
                    whiteSpace: 'pre-wrap',
                    lineHeight: 1.5,
                    textAlign: 'justify',
                    maxHeight: expanded ? 'none' : `${maxHeight}px`,
                    overflow: 'hidden',
                }}>
                    {value}
                </div>
                {!expanded && overflows && (
                    <div style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: '32px',
                        background: 'linear-gradient(transparent, var(--bg-color))',
                        pointerEvents: 'none',
                    }} />
                )}
            </div>
            {(overflows || expanded) && <button
                onClick={() => setExpanded(!expanded)}
                style={{
                    background: 'none',
                    border: 'none',
                    color: '#aaa',
                    cursor: 'pointer',
                    padding: '4px 0',
                    fontSize: '0.8rem',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    textDecoration: 'none',
                    transition: 'color 0.2s ease',
                }}
                onMouseEnter={e => e.currentTarget.style.color = 'var(--color)'}
                onMouseLeave={e => e.currentTarget.style.color = '#aaa'}
            >
                {expanded ? 'show less' : 'show more...'}
            </button>}
        </div>
    );
}

export default TextWithCut;
